module.exports = __webpack_public_path__ + "media/images/mailer/record_voice_over-48-primary-02c28e3c157a2791ab5766c39446da59.png";